<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <SearchForm
          v-if="active"
          :collections="currentDivisionEntities"
          @search="formSubmitted"
        />
        <v-alert
          v-else
          border="bottom"
          colored-border
          elevation="2"
          type="warning"
        >
          This feature is not available for this Division.
        </v-alert>
      </v-col>
    </v-row>
    <v-row v-if="result">
      <v-col cols="12">
        <v-card>
          <v-toolbar color="black" dark flat>
            <template v-slot:extension>
              <v-tabs v-model="tab" color="blue" dark fixed-tabs>
                <v-tabs-slider color="yellow"></v-tabs-slider>
                <v-tab v-for="item in tabs" :key="item.key" dark>
                  <StateTab :state="state(item.stateGetters)">
                    {{ item.tab }}
                  </StateTab>
                </v-tab>
              </v-tabs>
            </template>
          </v-toolbar>
          <v-card-text>
            <v-tabs-items v-model="tab">
              <v-tab-item v-for="item in tabs" :key="item.key">
                <component
                  :is="item.component"
                  :collection="collection"
                  :params="params"
                  :api="item.api"
                  :selector="selector"
                ></component>
              </v-tab-item>
            </v-tabs-items>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import SearchForm from '@/components/SearchForm.vue';
import NotIlmplementedYet from '@/views/Home/NotIlmplementedYet.vue';
import AtlasAPL from '@/views/Home/AtlasAPL.vue';
import AtlasAFH from '@/views/Home/AtlasAFH.vue';
import Cosmos from '@/views/Home/Cosmos.vue';
import Errors from '@/views/Home/Errors.vue';
import StateTab from '@/components/StateTab.vue';
import { createNamespacedHelpers } from 'vuex';

const { mapState: mapStateConfig } = createNamespacedHelpers('config');

export default {
  name: 'Home',
  components: { SearchForm, StateTab },
  watch: {
    currentDivision() {
      this.result = false;
    }
  },
  methods: {
    state(stateGetters) {
      return this.$store.getters[stateGetters]
        ? this.$store.getters[stateGetters]
        : 'UNKNOWN';
    },
    formSubmitted(values) {
      this.result = true;
      this.collection = values.collection;
      this.selector = values.collection.selector;
      this.params = { id: Object.values(values.values).join(',') };
      this.loadDatas();
    },
    loadDatas() {
      // We use promise.all to be sure we parallelize request
      Promise.all([
        this.getCosmosDocument(),
        this.getMongoAPLDocument(),
        this.getMongoAFHDocument(),
        this.getErrorsDocument()
      ]);
    },
    getCosmosDocument() {
      const params = {
        division: this.currentDivision,
        collection: this.collection.cosmos,
        keys: this.selector,
        ...this.params
      };
      this.$store.dispatch('home/cosmos/getDocument', params);
    },
    getMongoAPLDocument() {
      const params = {
        division: this.currentDivision,
        api: 'APL',
        collection: this.collection.mongo.APL,
        keys: this.selector,
        ...this.params
      };
      this.$store.dispatch('home/mongoAPL/getDocument', params);
    },
    getMongoAFHDocument() {
      const params = {
        division: this.currentDivision,
        api: 'AFH',
        collection: this.collection.mongo.AFH,
        keys: this.selector,
        ...this.params
      };
      this.$store.dispatch('home/mongoAFH/getDocument', params);
    },
    getErrorsDocument() {
      const params = {
        division: this.currentDivision,
        entity: this.collection.name,
        keys: this.selector,
        ...this.params
      };
      this.$store.dispatch('home/errors/getDocument', params);
    }
  },
  computed: {
    ...mapStateConfig(['entities', 'currentDivision']),
    currentDivisionEntities() {
      return this.entities[this.currentDivision];
    },
    active() {
      return this.currentDivision !== '3DIV';
    }
  },
  data() {
    const defaultTab = {
      key: 1,
      tab: 'Storage',
      type: 'storage',
      component: NotIlmplementedYet,
      state: null
    };
    return {
      collection: null,
      selector: null,
      params: null,
      result: false,
      tab: defaultTab,
      tabs: [
        defaultTab,
        {
          key: 2,
          tab: 'Cosmos',
          stateGetters: 'home/cosmos/state',
          component: Cosmos,
          state: this.$store.state.home.cosmos.state
        },
        {
          key: 3,
          tab: 'Mongo APL',
          stateGetters: 'home/mongoAPL/state',
          component: AtlasAPL,
          api: 'APL',
          state: this.$store.state.home.mongoAPL.state
        },
        {
          key: 4,
          tab: 'Mongo AFH',
          stateGetters: 'home/mongoAFH/state',
          component: AtlasAFH,
          api: 'AFH',
          state: this.$store.state.home.mongoAFH.state
        },
        {
          key: 5,
          tab: 'API PEARL',
          getState: null,
          component: NotIlmplementedYet,
          state: null
        },
        {
          key: 6,
          tab: 'Errors',
          stateGetters: 'home/errors/state',
          component: Errors,
          state: this.$store.state.home.errors.state
        }
      ]
    };
  }
};
</script>
